import { Pipe, PipeTransform } from '@angular/core';
import { Record } from '@src/suite/common/data-models/records/record';

@Pipe({
    name: 'fullName',
})
export class FullNamePipe implements PipeTransform {
    transform(PSTTopicOwners): string {
        return PSTTopicOwners?.map(ownerId => Record.globalTablesService.Staff[ownerId]?.DisplayName || ownerId).join(', ');
    }
}
